export var FolioStatus;
(function (FolioStatus) {
    FolioStatus["DRAFT"] = "DRAFT";
    FolioStatus["OPEN"] = "OPEN";
    FolioStatus["PAID"] = "PAID";
    FolioStatus["UNCOLLECTABLE"] = "UNCOLLECTABLE";
    FolioStatus["VOID"] = "VOID";
    FolioStatus["REFUNDED"] = "REFUNDED";
    FolioStatus["PREAUTHORIZED"] = "PREAUTHORIZED";
    FolioStatus["RELEASED"] = "RELEASED";
})(FolioStatus || (FolioStatus = {}));
